import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { ChatProvider } from "@/components/chat/ChatProvider";
import { ChatFAB } from "@/components/chat/ChatFAB";
import { cn } from "@/lib/utils";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <ChatProvider>
      <div className="flex h-screen overflow-hidden bg-background">
        {/* Skip navigation */}
        <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg">
          Pular para o conteudo principal
        </a>

        {/* Sidebar — desktop */}
        <div className="hidden md:flex">
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((prev) => !prev)} />
        </div>

        {/* Sidebar — mobile overlay */}
        {mobileOpen && (
          <>
            <div
              className="fixed inset-0 z-40 bg-foreground/30 md:hidden"
              onClick={(e) => { e.stopPropagation(); setMobileOpen(false); }}
              onKeyDown={(e) => { if (e.key === "Escape") setMobileOpen(false); }}
              aria-hidden="true"
            />
            <div className="fixed inset-y-0 left-0 z-50 md:hidden" role="dialog" aria-modal="true" aria-label="Menu de navegacao">
              <Sidebar collapsed={false} onToggle={() => setMobileOpen(false)} />
            </div>
          </>
        )}

        {/* Main area */}
        <div className={cn("flex flex-1 flex-col overflow-hidden")}>
          <Header onMenuClick={() => setMobileOpen((prev) => !prev)} />
          <main id="main-content" className="flex-1 overflow-y-auto p-3 sm:p-6">{children}</main>
        </div>

        <ChatFAB />
      </div>
    </ChatProvider>
  );
}
